import IMolangNode from "./IMolangNode";

export interface IMolangExpression {
  rootNode: IMolangNode;
}
